import {
  numberToCurrencyString,
  dateToLabel,
  pluralize,
} from 'further-ui/utils';

const getAllocationLabel = (allocation: {
  date: string;
  totalInvestmentAmount: number;
  numberOfTranches: number;
  numberOfInvestments?: number;
  shareClass?: string;
}) => {
  const date = dateToLabel(allocation.date);

  const amountInvested = numberToCurrencyString(
    allocation.totalInvestmentAmount,
  );

  const noOfTranches = `${allocation.numberOfTranches} ${pluralize(
    'tranche',
    allocation.numberOfTranches,
  )}`;

  const noOfInvestments = `${allocation?.numberOfInvestments} ${pluralize(
    'subscription',
    allocation?.numberOfInvestments,
  )}`;

  const shareClassPrefix = allocation.shareClass
    ? `${allocation.shareClass} - `
    : '';

  return `${shareClassPrefix}${date} - ${amountInvested} - ${noOfTranches} - ${noOfInvestments}`;
};

export default getAllocationLabel;
